'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = createComponent;

var _ReduxComponent = require('./ReduxComponent');

var _ReduxComponent2 = _interopRequireDefault(_ReduxComponent);

var _withSubtree = require('./decorators/withSubtree');

var _withSubtree2 = _interopRequireDefault(_withSubtree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTreeComponent(shape) {
	var clazz = (0, _withSubtree2.default)(function () {
		return shape;
	})(_ReduxComponent2.default);
	return new clazz();
}

function createComponent(descriptor) {
	if (descriptor instanceof _ReduxComponent2.default) {
		// Just a component
		return descriptor;
	} else if (typeof descriptor === 'function' && descriptor.prototype instanceof _ReduxComponent2.default) {
		// Class of component -- instantiate
		return new descriptor();
	} else if (typeof descriptor === 'function') {
		// Pure reducer function -- wrap
		var result = new _ReduxComponent2.default();
		result.reducer = descriptor.bind(result);
		return result;
	} else if ((typeof descriptor === 'undefined' ? 'undefined' : (0, _typeof3.default)(descriptor)) === 'object' && !!descriptor && !Array.isArray(descriptor)) {
		// Subtree descriptor -- wrap in subtree
		return createTreeComponent(descriptor);
	} else {
		throw new Error('invalid component descriptor');
	}
}